var exports = {
  "u": "ExternalLink.module__externalLink___TE1qVm",
};

module.exports = exports;
